import { gql } from '@apollo/client';

export const GENERATE_GUEST_CHAT_AUTH_TOKEN_MUTATION = gql`
  mutation GenerateGuestChatAuthToken($data: GenerateAuthTokenInput!) {
    generateGuestChatAuthToken(data: $data) {
      id
      chatAuthToken
      validUntil
    }
  }
`;
